import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';

import AssetsIcon from '../../../assets/images/assets.svg';
import OperationIcon from '../../../assets/images/oparation.svg';
import OnAirIcon from '../../../assets/images/onair.svg';
import OnLoanIcon from '../../../assets/images/onloan.svg';
import AssetsIconA from '../../../assets/images/assets_a.svg';
import OperationIconA from '../../../assets/images/oparation_a.svg';
import OnAirIconA from '../../../assets/images/onair_a.svg';
import OnLoanIconA from '../../../assets/images/onloan_a.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { MSGGRID, ULDSEARCH, ULDSEARCHDETAILS } from '../../../Utils/conts.js';
import MovementHistory from './components/MovementHistory.js';
import MHDetails from './components/MHDetails.js';
import Details from './components/Details.js';
import Assets from './ULD/Assets.js';
import InStock from './ULD/InStock.js';
import Onloan from './ULD/Onloan.js';
import Lease from './ULD/Lease.js';
import UCMIn from './UCM/UCMIn.js';
import UCMOut from './UCM/UCMOut.js';
import Dashboard from './UCM/Dashboard.js';
import SDashboard from './SCM/Dashboard.js';
import LUCOut from './LUC/LUCOut.js';
import LUCIn from './LUC/LUCIn.js';
import { TabButton } from '../../../Components/common/CommonFunctions.js';
import ULDFunction from './components/ULDFunction.js';
import Messages from './LUC/Messages.js';

const ULDControl = () => {

    const Asset_Tabs = [
        { value: 'assets', label: 'Assets', activeIcon: AssetsIconA, inactiveIcon: AssetsIcon },
        { value: 'instock', label: 'In Stock', activeIcon: OperationIconA, inactiveIcon: OperationIcon },
        { value: 'onloan', label: 'On Loan', activeIcon: OnLoanIconA, inactiveIcon: OnLoanIcon },
        { value: 'lease', label: 'Lease', activeIcon: OnAirIconA, inactiveIcon: OnAirIcon }
    ];
    const UCM_Tabs = [
        { value: 'D', label: 'Dashboard', activeIcon: AssetsIconA, inactiveIcon: AssetsIcon },
        { value: 'I', label: 'UCM In', activeIcon: OperationIconA, inactiveIcon: OperationIcon },
        { value: 'O', label: 'UCM Out', activeIcon: OnLoanIconA, inactiveIcon: OnLoanIcon }
    ];
    const SCM_Tabs = [];
    const LUC_Tabs = [
        { value: 'lo', label: 'LUC Out', activeIcon: AssetsIconA, inactiveIcon: AssetsIcon },
        { value: 'li', label: 'LUC In', activeIcon: OperationIconA, inactiveIcon: OperationIcon },
        { value: 'msg', label: 'Messages', activeIcon: OnLoanIconA, inactiveIcon: OnLoanIcon }
    ];


    const isMounted = useRef(false);
    const initialMTab = localStorage.getItem("HULD") || 'uld';
    const [mainTab, setMainTab] = useState(initialMTab);
    const [actTab, setActTab] = useState('');

    const sTab = {
        uld: 'assets',
        ucm: 'D',
        scm: '',
        luc: 'lo'
    }

    const initialSTab = localStorage.getItem("HULDtab") || sTab[mainTab];
    const [subTab, setSubTab] = useState(initialSTab);
    const initPage = localStorage.getItem("HULDpage") || '';
    const [innerPage, setInnerPage] = useState(initPage);
    const [apiNumber, setApiNumber] = useState(null);
    const [msgCount, setMsgCount] = useState();

    const handleMainClick = (button) => {
        setMainTab(button);
        localStorage.setItem('HULD', button);
    };
    const handleSubClick = (button) => {
        setSubTab(button);
        localStorage.setItem('HULDtab', button);
    };
    // const handlenewLink = (button) => {
    //     setInnerPage(button);
    //     localStorage.setItem('HULDpage', button);
    // };
    const handlenewLink = (page = '', main = null, sub = null, tab = '') => {
        console.log('page', page);

        setInnerPage(page);
        localStorage.setItem('HULDpage', page);

        if (main) {
            setMainTab(main);
            localStorage.setItem('HULD', main);
        }

        if (sub) {
            setSubTab(sub);
            localStorage.setItem('HULDtab', sub);
        }

        // if (tab) {
        //     setActTab(tab)
        // }
    };
    // autocomplete
    const [searchItems, setSearchItems] = useState([])
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(ULDSEARCH, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // const transformedData = innerData.map((name, index) => ({
                    //     id: index,
                    //     name: name
                    // }));
                    const transformedData = Object.entries(innerData).map(([key, value], index) => ({
                        id: key,
                        name: value
                    }));
                    setSearchItems(transformedData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchMsgrid = async () => {
        try {
            const res = await withRFSToken.post(MSGGRID, { type: 'O' })
                .then(function (res) {
                    const innerData = res.data;
                    const transformedData = {
                        openMsg: innerData.open_messages,
                        prsdMsg: innerData.processed_messages,
                        trshdMsg: innerData.trash_messages,
                    }
                    setMsgCount(innerData.open_messages);
                    // setApiNumber(innerData.total_data)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        fetchDataGrid();
        // fetchMsgrid();
        isMounted.current = true;
    }, []);
    useEffect(() => {
        setSubTab(initialSTab)
    }, [mainTab]);


    let navTabs = [];
    switch (mainTab) {
        case 'uld':
            navTabs = Asset_Tabs
            break;
        case 'ucm':
            navTabs = UCM_Tabs
            break;
        case 'luc':
            navTabs = LUC_Tabs
            break;
        default:
        // navTabs = Asset_Tabs
    }

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results)
    }

    const handleOnHover = (result) => {
        // the item hovered
        console.log(result)
    }

    const handleOnSelect = async (item) => {
        // the item selected
        console.log(item)
        try {
            const res = await withRFSToken.post(ULDSEARCHDETAILS, { uld_number: item.name });
            if (res.data.response_code == 200) {
                localStorage.removeItem('MHistory');
                const storageData = {
                    ULD: res.data.response_data,  // ULD Details section
                    Form: {}  // Empty form section
                };
                localStorage.setItem('MHistory', JSON.stringify(storageData));
                localStorage.setItem('HULDtab', initialSTab);
                window.location.href = '/ULDControl/MovementHistory'
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleOnFocus = () => {
        // console.log('Focused')
    }

    return (
        <>
            <div className="">
                <Header page_type='uld' logo_url='/ULDControl' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    {innerPage === '' &&
                        <div className="main-panel rounded">
                            <div className="mainTab">
                                <TopMenu module='HULD' onTab={handleMainClick} selectedTab={mainTab} />
                                <div className="">
                                    <div className="allcontent-fl">
                                        <div className='d-flex justify-content-between mb-3'>
                                            <div>
                                                {navTabs.map(tab => (
                                                    <TabButton
                                                        key={tab.value}
                                                        value={tab.value}
                                                        label={tab.label}
                                                        selectedButton={subTab}
                                                        onClick={() => handleSubClick(tab.value)}
                                                        activeIcon={tab.activeIcon}
                                                        inactiveIcon={tab.inactiveIcon}
                                                    />
                                                ))}
                                            </div>
                                            <div className='search'>
                                                <div className="form-group has-search">

                                                    <ReactSearchAutocomplete
                                                        items={searchItems}
                                                        onSearch={handleOnSearch}
                                                        onHover={handleOnHover}
                                                        onSelect={handleOnSelect}
                                                        onFocus={handleOnFocus}
                                                        autoFocus
                                                        placeholder="Search ULD"
                                                    // formatResult={formatResult}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="lcontent">
                                            {mainTab === 'uld' &&
                                                <>
                                                    {subTab === 'assets' &&
                                                        <Assets
                                                            linkClick={handlenewLink}
                                                            mhClick={() => handlenewLink('MH')}
                                                            mdClick={() => handlenewLink('MD')}
                                                        />
                                                    }
                                                    {subTab === 'instock' &&
                                                        <InStock
                                                            linkClick={handlenewLink}
                                                            mhClick={() => handlenewLink('MH')}
                                                            mdClick={() => handlenewLink('MD')}
                                                        />
                                                    }
                                                    {subTab === 'onloan' && <Onloan linkClick={handlenewLink} />}
                                                    {subTab === 'lease' && <Lease />}
                                                </>
                                            }
                                            {mainTab === 'ucm' &&
                                                <>
                                                    {subTab === 'D' && <Dashboard />}
                                                    {subTab === 'I' && <UCMIn />}
                                                    {subTab === 'O' && <UCMOut />}
                                                </>
                                            }
                                            {mainTab === 'scm' &&
                                                <>
                                                    <SDashboard />
                                                </>
                                            }
                                            {mainTab === 'luc' &&
                                                <>
                                                    {subTab === 'lo' && <LUCOut tabs={actTab} linkClick={() => handlenewLink('UF', 'luc', 'lo')} />}
                                                    {subTab === 'li' && <LUCIn linkClick={() => handlenewLink('UF', 'luc', 'li')} />}
                                                    {subTab === 'msg' && <Messages />}
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {innerPage === 'MH' && <MovementHistory onBack={() => handlenewLink('')} mdClick={() => handlenewLink('MD')} />}
                    {innerPage === 'MD' && <MHDetails onBack={() => handlenewLink('MH')} />}
                    {innerPage === 'D' && <Details onBack={() => handlenewLink('')} />}
                    {innerPage === 'UF' &&
                        <ULDFunction
                            onBack={() => handlenewLink('')}
                            goBackLoan={() => handlenewLink('', 'uld', 'onloan')}
                            goBackLuckO={() => handlenewLink('', 'luc', 'lo', 'Archived')}
                            goBackLuckI={() => handlenewLink('', 'luc', 'li', 'Archived')}
                            goBackLuckA={() => handlenewLink('', 'uld', 'assets')}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default ULDControl